module.exports = __webpack_public_path__ + "img/samll_active_icon.39c60665.png";